/**
 *  Component: Guide Section
 */
import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import JiraGoalImage1 from 'assets/images/jiraGoalImage1.jpg';
import JiraGoalImage2 from 'assets/images/jiraGoalImage2.jpg';

import {
  NotificationIcon1,
  GoalsIcon,
  ManagementIcon,
  ApplauseIcon,
  Deadline1Icon,
  Deadline2Icon,
  InterviewIcon,
  CustomerFeedbackIcon,
  CheckMarkIcon,
} from 'constants/icons';

import { FormContainer, FormHeading, Separator, Icon } from '../styles';
import IconWithText from './iconWithText';

const GuideSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <NotificationIcon1 size="fixed18px" />
      </Icon>
      On Mesh you'll get notified of the following
    </FormHeading>
    <Separator />
    <Container>
      <Grid container>
        <Grid xs="4" container direction="column">
          <Grid>
            <IconWithText
              icon={<GoalsIcon size="smaller" color="#3A8EE9" />}
              text="Get updated when a new Goal is created on business objectives"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<CustomerFeedbackIcon size="smaller" color="#3A8EE9" />}
              text="View activity of what Tasks your team members will deliver on"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<ManagementIcon size="smaller" color="#3A8EE9" />}
              text="See collaborative action of which team members will be working on projects and tasks together"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<InterviewIcon size="smaller" color="#3A8EE9" />}
              text="Provide feedback in a constructive and continuous manner on Mesh whenever you’re notified that a goal or task has been created within Jira"
            />
          </Grid>
        </Grid>
        <Grid xs="4" container direction="column">
          <StrokedImage src={JiraGoalImage1} />
          <ShadowedImage src={JiraGoalImage2} />
        </Grid>
        <Grid xs="4" container direction="column">
          <Grid>
            <IconWithText
              icon={<Deadline2Icon size="smaller" color="#3A8EE9" />}
              text="Easily see when deadlines have been updated or extended"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<CheckMarkIcon size="smaller" color="#3A8EE9" />}
              text="Whenever anyone updates a Initiative or Goal, it'll also show on Mesh!"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<Deadline1Icon size="smaller" color="#3A8EE9" />}
              text="Helping you stay updated and on top of you work is a lot easier with Jira on Mesh!"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<ApplauseIcon size="smaller" color="#3A8EE9" />}
              text="Appreciating your colleagues for a job well done is simple since you'll get notified whenever goals and tasks are completed"
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </FormContainer>
);

const Container = styled.div`
  padding: 2rem 2rem 30px 24px;
`;

const StrokedImage = styled.img`
  width: 90%;
  border: 1px solid #eee;
`;

const ShadowedImage = styled.img`
  width: 90%;
  box-shadow: -1px 0px 12px 4px rgba(0, 0, 0, 0.13);
`;

export default GuideSection;
